"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chip = require("./Chip.styles");

var _cross = _interopRequireDefault(require("../../assets/images/cross"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Chip = ({
  children,
  onRemove,
  showRemoveIcon,
  disabled,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_Chip.StyledChip, _extends({
    "data-testid": "chip",
    disabled: disabled
  }, props), children, showRemoveIcon && /*#__PURE__*/_react.default.createElement(_Chip.StyledCloseButton, {
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_cross.default, {
    "data-testid": "chip_remove_icon",
    onClick: e => onRemove(e, props)
  })));
};

exports.Chip = Chip;
Chip.defaultProps = {
  disabled: false,
  onRemove: () => null,
  showRemoveIcon: true
};
Chip.propTypes = {
  /** Chip can be element, string, number boolean  */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.element, _propTypes.default.node]).isRequired,

  /** a callback function on Click on Remove icon which will contain both event and id 'e => onClose(e, id)'*/
  onRemove: _propTypes.default.func.isRequired,

  /** a boolean value to disable */
  disabled: _propTypes.default.bool,

  /** A value to enable remove Icon */
  showRemoveIcon: _propTypes.default.bool
};